import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Auth } from '../../../../decorators/auth.decorator';
import { CurrentSearchParams } from '../../../../decorators/current-search-params.decorator';
import { IsLoggedIn } from '../../../../decorators/is-logged-in.decorator';
import { Subscribe } from '../../../../decorators/subscribe.decorator';
import { CityWithChild } from '../../../../domains/city-with-child';
import { CountryWithChild } from '../../../../domains/country-with-child';
import { CountyWithChild } from '../../../../domains/county-with-child';
import { StateWithChild } from '../../../../domains/state-with-child';
import { SearchFiltersPosition } from '../../../../models/enums/search-filters-position';
import { SidenavType } from '../../../../models/enums/sidenav-type';
import { LocationFavorites } from '../../../../models/location-favorites';
import { SearchParams } from '../../../../models/search-params';
import { SearchResult } from '../../../../models/search-result';
import { SearchFiltersPositionWrapper } from '../../../../models/wrappers/search-filters-position.wrapper';
import { FavoritesService } from '../../../../services/favorites.service';
import { LayoutSidenavService } from '../../../../services/layout-sidenav.service';
import { NavigatorService } from '../../../../services/navigator.service';

@Component({
  selector: 'app-search-desktop-topnav',
  templateUrl: './search-desktop-topnav.component.html',
  styleUrls: [
    '../../../topnav/desktop-topnav/desktop-topnav.component.scss',
    '../../../../../vendor/libs/ng-select/ng-select.scss',
  ]
})
export class SearchDesktopTopnavComponent implements OnInit {
  @Input() searchResult: SearchResult;
  @Input() country: CountryWithChild;
  @Input() preview = false;
  @Input() locationFavorites: LocationFavorites;
  @Input() isSearching = false;

  @Output() videoModalClicked = new EventEmitter<boolean>();
  @Output() citySelected = new EventEmitter<CityWithChild>();
  @Output() previewChange = new EventEmitter<boolean>();
  @Output() locationDropdownChange = new EventEmitter<boolean>();
  @Output() localitySelectedChange = new EventEmitter<boolean>();
  @Output() countyChange = new EventEmitter<CountyWithChild>();
  @Output() stateChange = new EventEmitter<StateWithChild>();

  @IsLoggedIn() isLoggedIn: boolean;

  @CurrentSearchParams() searchParams: SearchParams;

  logoMouseOver = false;
  isHovered = false;
  searchFiltersPositionUnderLogo = new SearchFiltersPositionWrapper(SearchFiltersPosition.IS_DESKTOP_NAVBAR);

  constructor(
    private navigatorService: NavigatorService,
    private favoritesService: FavoritesService,
    private layoutSidenavService: LayoutSidenavService
  ) {
  }

  ngOnInit(): void {
  }

  @Auth()
  goToUser() {
    this.navigatorService.goToUser();
  }

  openVideoModal() {
    this.videoModalClicked.emit(true);
  }

  @Auth()
  onFavoriteClick() {
    this.favoritesService.favoriteClickSubject.next(true);
  }

  onCitySelected(citySelected: CityWithChild) {
    this.citySelected.emit(citySelected);
  }

  onPreviewChange() {
    this.previewChange.emit(true);
  }

  onLocationDropdownChange() {
    this.locationDropdownChange.emit(true);
  }

  onLocalitySelectedChange(isLocalitySelected: boolean) {
    this.localitySelectedChange.emit(isLocalitySelected);
  }

  onStateChange(event: StateWithChild) {
    this.stateChange.emit(event);
  }

  onCountyChange(event: CountyWithChild) {
    this.countyChange.emit(event);
  }

  @Auth()
  @Subscribe()
  openMembershipModal() {
  }

  setLogoHover(sidenavHover: boolean) {
    this.logoMouseOver = sidenavHover;
    this.layoutSidenavService.sidenavIsMouseOverSubjects[SidenavType.RIGHT].next(sidenavHover);
  }
}
